import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
    referralFormContainer: {
        position: 'relative',
        '& h2': {
            fontSize: '26px',
            lineHeight: '34px',
            color: '#4a4a4a',
            textAlign: 'center',
            margin: '0 0 3rem 0',
            fontWeight: '600',
            letterSpacing: '-1px',
        },

    },
    referralFormDetails: {
        margin: "42px auto",
        textAlign: "center",
        color: "#a4a4a4",
        fontSize: 16,
        fontFamily: "CircularStd",
        '& span': {
            color: "#4a4a4a"
        }
    },
    referralFormItemContainer: {
        // boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
        marginBottom: 30
    },
    referralFormItem: {
        display: 'flex',
        flexWrap: 'wrap',
        background: 'white',
        padding: '25px 30px',
        borderBottom: '1px solid rgba(45,145,233, 0.1)',
        fontSize: 16,
        lineHeight: '18px',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease-in-out',
        '&:hover': {
            background: '#f5f5f5',
        },
        '& span': {
            letterSpacing: '-0.5px',
            '&:first-child': {
                marginRight: '.875em',
                '& svg': {
                    width: '1.375em',
                    height: '1.375em',
                },
            },
            '&:last-child': {
                color: '#2D91E9',
                marginLeft: 'auto',
                '& svg': {
                    display: 'inline-block',
                    paddingRight: 5
                },
            },
        },
    },
    generateButton: {
        width: 190,
        margin: "0 auto",
        display: "flex",
        justifyContent: "center"
    },
    svgTick: {
        marginRight: 6,
    },
    svgIconClose: {
        cursor: 'pointer',
        pointerEvents: 'all',
        marginLeft: 'auto'
    }

});
